import ProductionQualityInspectionVisualDetail from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetail';

export default class ProductionQualityInspectionVisualDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.productionQualityInspectionVisualId  = '';
		this.productionQualityInspectionVisualInspectionNumber = '';
		this.workOrderExecutionNgId  = '';
		this.workOrderExecutionNgWorkOrderExecutionDetail = '';
		this.problemCategoryId  = '';
		this.problemCategoryCode = '';
		this.ngQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			productionQualityInspectionVisualId : '0',
			productionQualityInspectionVisualInspectionNumber : '0',
			workOrderExecutionNgId : '0',
			workOrderExecutionNgWorkOrderExecutionDetail : '0',
			problemCategoryId : '0',
			problemCategoryCode : '0',
			ngQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}